// extracted by mini-css-extract-plugin
module.exports = {"data":"tableData_data__3bXw8"};